import { z } from "zod";

import { imageSchema } from "./image";

export const viewSchema = z.object({
  code: z.string(),
  name: z.string(),
  images: z.array(imageSchema),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type View = z.infer<typeof viewSchema>;
